





















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ScrollIndicator from './ScrollIndicator.vue';


@Component({
    components: {
        ScrollIndicator
    }
})
export default class TheHomePageHeader extends Vue {
   onHamburgerMenuClick() {
        console.log(`Opening hamburger menu ${this.$store.state.isOverlayMenuOpen}`);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.$store.commit("openOverlayMenu");
   }
}
